export const hostStyleSheet = new CSSStyleSheet();
hostStyleSheet.replaceSync(`
    :host {
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        box-sizing: border-box;
        width: 100dvw;
        height: 100dvh;
        background-color: rgba(0, 0, 0, 0.2);
    }
`);
